import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostData_importBatches_idUndo = z.any()
export type TagsPostData_importBatches_idUndo = z.infer<typeof tagsPostData_importBatches_idUndo>

export const paramsPostData_importBatches_idUndo = z.object({ "id": z.string().uuid() })
export type ParamsPostData_importBatches_idUndo = z.infer<typeof paramsPostData_importBatches_idUndo>

export const bodyPostData_importBatches_idUndo = z.object({ "undoToken": z.string().min(64).max(64).optional() })
export type BodyPostData_importBatches_idUndo = z.infer<typeof bodyPostData_importBatches_idUndo>

export const responsePostData_importBatches_idUndo = z.object({ "payload": z.object({ "batchId": z.string(), "canUndo": z.boolean(), "undone": z.boolean(), "undoToken": z.string(), "blockers": z.array(z.string()), "records": z.number().int() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostData_importBatches_idUndo = z.infer<typeof responsePostData_importBatches_idUndo>

interface IPostData_importBatches_idUndo extends BaseMethodType {
  tags: TagsPostData_importBatches_idUndo,
  params: ParamsPostData_importBatches_idUndo,
  body: BodyPostData_importBatches_idUndo,
  response: ResponsePostData_importBatches_idUndo
}
export const URL = '/data-import/batches/:id/undo'
export const validation = {
  post: {
    tags: tagsPostData_importBatches_idUndo,
    params: paramsPostData_importBatches_idUndo,
    body: bodyPostData_importBatches_idUndo,
    response: responsePostData_importBatches_idUndo
  }
}
export interface Data_importBatches_idUndo extends BaseRouteType {
  post: IPostData_importBatches_idUndo
}